import React from "react";

function BrandButton(props) {
  return (
    <div onClick={props.onClick} className={`${props.class}`}>
      <button type={props.type} className="button">
        {props.title}
      </button>
    </div>
  );
}

export default BrandButton;
